import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "growing_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-retry once on a transient failure (network error or 502/503/504), e.g. a
// cold-started backend on the very first request — avoids the spurious "try again".
client.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  const status = error?.response?.status;
  const transient = !error.response || [502, 503, 504].includes(status);
  if (cfg && transient && !cfg._retried) {
    cfg._retried = true;
    await new Promise((r) => setTimeout(r, 700));
    return client(cfg);
  }
  return Promise.reject(error);
});

function errMessage(e) {
  const detail = e?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join("; ");
  if (detail && typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return detail || e?.message || "Request failed";
}

export async function apiGet(path, config) {
  try {
    const { data } = await client.get(path, config);
    return data;
  } catch (e) {
    throw new Error(errMessage(e));
  }
}
export async function apiPost(path, body, config) {
  try {
    const { data } = await client.post(path, body, config);
    return data;
  } catch (e) {
    throw new Error(errMessage(e));
  }
}
export async function apiPatch(path, body) {
  try {
    const { data } = await client.patch(path, body);
    return data;
  } catch (e) {
    throw new Error(errMessage(e));
  }
}
export async function apiDelete(path) {
  try {
    const { data } = await client.delete(path);
    return data;
  } catch (e) {
    throw new Error(errMessage(e));
  }
}

export { client };
